import React from "react";
import BaseComponent from "core/gd-components/base-component/base-component";

import {EditorState, Modifier, RichUtils, SelectionState} from "draft-js";

import Modal from "../components/modal";
import FormManager from "../../../gd-form/common/form-manager";
import Input from "../../../gd-form/form-element/input/input";
import FormError from "../../../gd-form/common/form-error/form-error";
import Form from '../../../gd-form/form/form-modal/form-modal';

export default class LinkSource extends BaseComponent {
    constructor(props) {
        super(props);
        this._bind('onSubmit', 'onRequestClose', 'onAfterOpen');

        const { entity } = props;

        let initFormData = {url: ''};

        if (entity) {
            const data = entity.getData();
            initFormData.url = data.url ? data.url : '';
        }

        const formStructure = {
            fields: {
                url: {
                    type: 'input',
                    isRequired: true,
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    componentDidMount() {
        gd.bus.triggerEvent('rich-editor:link-source-open', true);
    }

    componentWillUnmount() {
        gd.bus.triggerEvent('rich-editor:link-source-open', false);
    }

    onSubmit(result) {
        const { editorState, entityType, onComplete } = this.props;
        let contentState = editorState.getCurrentContent();

        let selection = editorState.getSelection();
        const data = {url: result.url.replace(/\s/g, "")};

        let nextEditorState = editorState;
        if (selection.anchorOffset === selection.focusOffset) {
            contentState = Modifier.insertText(contentState, selection, data.url);
            nextEditorState = EditorState.push(nextEditorState, contentState, 'insert-characters');

            selection = new SelectionState({
                anchorKey: selection.getAnchorKey(),
                anchorOffset: selection.anchorOffset,
                focusKey: selection.getAnchorKey(),
                focusOffset: selection.anchorOffset + data.url.length,
            });
        }

        const contentStateWithEntity = contentState.createEntity(entityType.type, "MUTABLE", data);
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

        nextEditorState = RichUtils.toggleLink(
            nextEditorState,
            selection,
            entityKey,
        );

        /*nextEditorState = EditorState.forceSelection(
            nextEditorState,
            contentStateWithEntity.getSelectionAfter(),
        );*/

        this.form.reset();

        onComplete(nextEditorState);
    }

    onRequestClose(e) {
      const { onClose } = this.props;
      e.preventDefault();

      onClose();
    }

    onAfterOpen() {if (this.urlInput) this.urlInput.focus()}

    onKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.keyCode === 13) this.form.onSubmitClick();
    }

    render() {
        const { entity } = this.props;
        const title = entity ? "Edit link" : "Add link";

        return (
            <Modal onRequestClose={this.onRequestClose}
                   onAfterOpen={this.onAfterOpen}
                   isOpen={true}
                   contentLabel="Link chooser" >
                <div className="header">
                    <div className="title">{title}</div>
                    <div className="i5-delete" onClick={this.onRequestClose}> </div>
                </div>
                <Form form={this.form} className="gd-rich-editor-link-source-form">

                    <div className="row cf">
                        <div className="label">Link URL</div>
                        <div className="element">
                            <Input ref={r=>this.urlInput = r} size="big" form={this.form} name="url" placeholder="www.goodday.com" onKeyDown={this.onKeyDown}/>
                        </div>
                        <div className="cf" />
                        <FormError form={this.form} name="url" />
                    </div>
                </Form>
            </Modal>
        );
    }
}